<div
  class="storage-selector-container"
  [ngClass]="{
    'no-files': !hasRegularFileItems(),
    'folder-upload': isFileType('folder'),
  }"
>
  <div class="row storage-selector-search-container">
    <div class="col-xs-12">
      <search-filter
        [filterConfig]="filterConfig"
        [search]="search"
        [doSearch]="list.doSearch"
        [localSearch]="true"
      ></search-filter>
    </div>
  </div>
  <div
    class="storage-selector-component te-scrollable-container tw-relative"
    [ngClass]="{ 'no-files': !hasRegularFileItems() }"
    rvSpinner="component-storage-selector-spinner"
    [rvShowSpinner]="storageManagerService.loadingFiles"
  >
    @if (storageManagerService.loadingFiles) {
      <div role="status" aria-live="polite" class="sr-only">
        Loading storage files...
      </div>
    }
    @if (storageManagerService.isListView) {
      <div
        class="file-component-list"
        [shown]="
          list.folderItems.length > 0 &&
          !isUploading &&
          !storageManagerService.loadingFiles
        "
      >
        <div
          class="pl-0 file-component-list-header"
          [hidden]="list.sortedItems.length === 0"
        >
          <div class="file-entry">
            @if (
              !this.storageManagerService.isSingleFileSelector ||
              !storageManagerService.isSingleFileSelector()
            ) {
              <mat-checkbox
                (click)="selectAllItems()"
                [ngModel]="search.selectAll"
              ></mat-checkbox>
            }
            <div
              class="mr-auto u_clickable"
              (click)="sortBy(fileNameOrderFunction)"
            >
              File name
              @if (search.sortBy === fileNameOrderFunction) {
                <i
                  [attr.aria-label]="
                    search.reverse ? 'Descending order' : 'Ascending order'
                  "
                  class="fa"
                  [ngClass]="
                    { false: 'fa-caret-up', true: 'fa-caret-down' }[
                      search.reverse
                    ]
                  "
                ></i>
              }
            </div>
            <div
              class="u_clickable"
              (click)="sortBy(dateModifiedOrderFunction)"
            >
              Last modified
              @if (search.sortBy === dateModifiedOrderFunction) {
                <i
                  [attr.aria-label]="
                    search.reverse ? 'Descending order' : 'Ascending order'
                  "
                  class="fa"
                  [ngClass]="
                    { false: 'fa-caret-up', true: 'fa-caret-down' }[
                      search.reverse
                    ]
                  "
                ></i>
              }
            </div>
          </div>
        </div>
        @for (item of list.sortedItems; track item) {
          <div>
            @if (isFolder(item.name)) {
              <div
                class="pl-0 file-component-list-folder-row u_clickable"
                [ngClass]="{ active: isSelected(item) }"
              >
                <div class="file-entry">
                  @if (isFileType('folder')) {
                    <mat-checkbox
                      [ngModel]="isSelected(item)"
                      (click)="selectItem(item)"
                    ></mat-checkbox>
                    <div
                      class="file-text tw-flex tw-flex-row tw-items-center"
                      (click)="loadItems(item.name)"
                    >
                      <mat-icon
                        svgIcon="folder"
                        class="tw-text-gray-500 tw-mr-[5px]"
                      ></mat-icon>
                      <div
                        class="file-name tw-font-semibold tw-text-sm"
                        title="{{ fileNameOf(item.name) }}"
                      >
                        {{ fileNameOf(item.name) }}
                      </div>
                    </div>
                  } @else {
                    <mat-icon
                      svgIcon="folder"
                      class="tw-text-gray-500 tw-mx-1.5"
                    ></mat-icon>
                    <div
                      class="file-text tw-flex tw-flex-row"
                      (click)="loadItems(item.name)"
                    >
                      <div
                        class="file-name tw-font-semibold tw-text-sm"
                        title="{{ fileNameOf(item.name) }}"
                      >
                        {{ fileNameOf(item.name) }}
                      </div>
                    </div>
                  }
                </div>
              </div>
            } @else {
              <div
                class="pl-0 file-component-list-file-row u_clickable"
                (click)="selectItem(item)"
              >
                <div class="file-entry">
                  <mat-checkbox [ngModel]="isSelected(item)"></mat-checkbox>
                  <div class="file-text mr-auto">
                    <div
                      class="file-name tw-font-semibold tw-text-sm"
                      title="{{ fileNameOf(item.name) }}"
                    >
                      {{ fileNameOf(item.name) }}
                    </div>
                  </div>
                  <div [hidden]="item.kind === 'folder'">
                    {{ item.updated?.value | date: 'MMM d, yyyy' }}
                  </div>
                </div>
              </div>
            }
          </div>
        }
        @if (list.sortedItems.length === 0) {
          <div id="noSearchResult" class="item-list-empty">
            No Results Found
          </div>
        }
      </div>
    }
    @if (!storageManagerService.isListView) {
      <div
        class="storage-selector-grid"
        [shown]="
          list.folderItems.length > 0 &&
          !isUploading &&
          !storageManagerService.loadingFiles
        "
      >
        @for (item of list.sortedItems; track item) {
          <div class="storage-row">
            <div>
              @if (isFolder(item.name)) {
                <div class="folder-entry" (click)="loadItems(item.name)">
                  <a actionLink>
                    <streamline-icon
                      aria-hidden="true"
                      name="folder"
                      width="38"
                      height="30"
                    ></streamline-icon>
                    <div
                      class="folder-name"
                      title="{{ fileNameOf(item.name) }}"
                    >
                      {{ fileNameOf(item.name) }}
                    </div>
                  </a>
                </div>
              } @else if (fileType !== 'video') {
                <div class="file-entry" (click)="selectItem(item)">
                  <a actionLink [attr.aria-labelledby]="item.id">
                    <img
                      loading="lazy"
                      [alt]="'Select image: ' + fileNameOf(item.name)"
                      [src]="thumbnailFor(item)"
                    />
                    <label
                      title="{{ fileNameOf(item.name) }}"
                      class="file-name tw-text-xs tw-w-full tw-text-center tw-truncate"
                    >
                      {{ fileNameOf(item.name) }}
                    </label>
                  </a>
                </div>
              } @else {
                <div class="video-entry" (click)="selectItem(item)">
                  <a actionLink [attr.aria-labelledby]="item.id">
                    <streamline-icon
                      aria-hidden="true"
                      name="video"
                    ></streamline-icon>
                    <label
                      id="{{ item.id }}"
                      title="{{ fileNameOf(item.name) }}"
                      class="video-name tw-text-xs tw-w-full tw-text-center tw-truncate"
                    >
                      {{ fileNameOf(item.name) }}
                    </label>
                  </a>
                </div>
              }
              @if (isSelected(item)) {
                <div class="overlay-entry" (click)="selectItem(item)">
                  <streamline-icon
                    ariaLabel="Item selected"
                    class="overlay-icon"
                    name="checkmark"
                    width="38"
                    height="28"
                  ></streamline-icon>
                </div>
              }
            </div>
          </div>
        }
        @if (list.sortedItems.length === 0) {
          <div id="noSearchResult">
            <p>No Results Found</p>
          </div>
        }
      </div>
    }
    <div
      class="item-list-empty"
      [shown]="
        list.folderItems.length === 0 &&
        !isUploading &&
        !storageManagerService.loadingFiles
      "
    >
      <div class="row">
        <div class="col-xs-12">
          <h2 [shown]="!currentFolder">
            You have no {{ fileTypeName }} in Storage.
          </h2>
          <h2 [shown]="currentFolder">
            You have no {{ fileTypeName }} in {{ currentFolder }}.
          </h2>
          <p>
            Upload {{ fileTypeName }} from your device to keep your display
            interesting!
          </p>
          <div>
            <img class="img-responsive" src="../images/empty-list.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
    <basic-uploader
      [uploaderId]="storageSelectorId + '-folder-uploader'"
      [uploadManager]="storageUploadManager"
      [validType]="folderType"
      [shown]="isUploading"
    >
    </basic-uploader>
    <basic-uploader
      [uploaderId]="storageSelectorId + '-file-uploader'"
      [uploadManager]="storageUploadManager"
      [validType]="fileType"
      [shown]="isUploading"
    >
    </basic-uploader>
  </div>
  <div class="storage-selector-action-button-bar">
    <div class="pt-4 border-top">
      <button
        rv-button
        variant="secondary"
        class="tw-w-full"
        id="upload-file-unsubscribed"
        (click)="currentPlanService.showUnlockThisFeatureModal()"
        [hidden]="currentPlanService.isPlanActive()"
      >
        <strong class="u_capitalize">Upload {{ fileTypeName }}</strong>
      </button>
      <button
        rv-button
        [variant]="hasRegularFileItems() ? 'secondary' : 'primary'"
        id="{{ storageSelectorId }}-file-uploader-label"
        class="tw-w-full"
        (click)="activateUploader('file')"
        [disabled]="isUploading"
        [shown]="currentPlanService.isPlanActive()"
      >
        <strong class="u_capitalize">Upload {{ fileTypeName }}</strong>
      </button>
    </div>
    @if (isFileType('folder')) {
      <div class="mt-3">
        <button
          rv-button
          variant="secondary"
          class="tw-w-full"
          id="upload-folder-unsubscribed"
          (click)="currentPlanService.showUnlockThisFeatureModal()"
          [hidden]="currentPlanService.isPlanActive()"
        >
          <strong class="u_capitalize">Upload Folder</strong>
        </button>
        <button
          rv-button
          variant="secondary"
          class="tw-w-full"
          id="{{ storageSelectorId }}-folder-uploader-label"
          (click)="activateUploader('folder')"
          [disabled]="isUploading"
          [shown]="currentPlanService.isPlanActive()"
        >
          <strong class="u_capitalize">Upload Folder</strong>
        </button>
      </div>
    }
    <div class="mt-3" [shown]="hasRegularFileItems()">
      <button
        rv-button
        id="{{ storageSelectorId }}-add-selected"
        class="tw-w-full"
        (click)="addSelected()"
        [disabled]="isUploading || selectedItems.length === 0"
      >
        <strong>Add Selected</strong>
      </button>
    </div>
  </div>
</div>
